import { de, enGB, es, fr, it } from 'date-fns/locale';

export const LOCALES_MAP = {
  fr: fr,
  en: enGB,
  es: es,
  it: it,
  de: de,
} as const;
